import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const AUTH_PAGES = ["/login", "/forgot-password", "/reset-password"];
const isAuthEndpoint = (url = "") =>
  ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot", "/auth/reset", "/auth/change-password"].some((p) => url.includes(p));

let refreshPromise = null;

// On a 401 for a normal request, try to silently refresh the access token once
// (refresh cookie lives 7 days). This keeps the session alive across page refreshes
// and navigation. If refresh fails, redirect to /login (unless already on an auth page).
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 401 && !original._retry && !isAuthEndpoint(original.url || "")) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (e) {
        refreshPromise = null;
        const path = typeof window !== "undefined" ? window.location.pathname : "";
        if (!AUTH_PAGES.some((p) => path.startsWith(p))) {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
